define('lq/events/actions/generateText',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function GenerateText(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(GenerateText, EventAction);

    GenerateText.typeName = 'GenerateText';

    GenerateText.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    GenerateText.prototype.execute = function (continuation, eventActionResponse) {
        var generatedText = this.piping.parameters.replace(this.eventData.textTemplate);
        this.piping.parameters.locals.setValue(this.eventData.targetParameter, generatedText);
        continuation();
    };

    return GenerateText;
});
